import {
  Button,
  Select,
  SelectOption,
  TextInput,
} from "@wearewqa/wqa-design-system";
import React, { ChangeEvent, FormEvent, useEffect, useState } from "react";
import { Modal } from "../components/Modal/Modal";
import { getStores } from "../resources/stores";
import { createEnvironment } from "../resources/environments";
import { Heading } from "../components/Heading";
import { FileInput } from "../components/FileInput";
import { Spinner } from "../components";

type CreateEnvironmentModalProps = {
  isOpen: boolean;
  onClose: () => void;
  appId: string;
};

type CreateEnvironmentFormData = {
  version_number: string;
  display_name: string | null;
  store_id: string;
  app_id: string;
};

export const CreateEnvironmentModal = ({
  appId,
  isOpen,
  onClose,
}: CreateEnvironmentModalProps) => {
  const [stores, setStores] = useState<SelectOption[] | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [file, setFile] = useState<File | null>(null);
  const [formData, setFormData] = useState<CreateEnvironmentFormData>({
    version_number: "",
    display_name: null,
    store_id: "",
    app_id: appId,
  });

  function onFileChange(event: ChangeEvent<HTMLInputElement>) {
    if (event.target.files) {
      setFile(event.target.files[0]);
    }
  }

  function onInputChange(key: string, value: string) {
    setFormData((prevState) => ({ ...prevState, [key]: value }));
  }

  async function manageFormSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setIsLoading(true);
    if (!file) {
      throw new Error("File is missing. Please add a file.");
    }

    try {
      const environment = await createEnvironment(formData, file);
      if (environment) {
        console.log(
          `Success. Environment '${environment.display_name || environment.version_number}' has been created.`
        );
        window.location.reload();
      }
      setIsLoading(false);
    } catch (error) {
      console.error("AdminEnvironmentForm - ManageFormSubmit: ", error);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    async function buildData() {
      try {
        const storesData = await getStores();

        const storeSelectOptions: SelectOption[] = storesData.body.map(
          (current) => ({
            label: current.name,
            value: current.id as string,
          })
        );

        setStores(storeSelectOptions);
      } catch (error) {
        console.error("AdminEnvironmentForm - buildData: ", error);
      }
    }

    void buildData();
  }, []);

  const baseClassname = "create-environment-modal";

  return (
    <Modal {...{ isOpen, onClose }}>
      <div className={`${baseClassname}`}>
        <Heading type="h2" label="Upload a new Environment." />
        <br />
        <form
          className={"modal-form"}
          onSubmit={(e) => void manageFormSubmit(e)}
        >
          {stores !== null && (
            <>
              <div className="modal-form__store-inputs">
                <Select
                  id={"environment_form__stores"}
                  label={"Select an store."}
                  options={stores}
                  value={formData.store_id}
                  required
                  onChange={(e) => onInputChange("store_id", e)}
                />
              </div>

              <TextInput
                required
                id={"environment_form__name"}
                label={"Version Number"}
                onChange={(event: ChangeEvent<HTMLInputElement>) =>
                  onInputChange("version_number", event.target.value)
                }
              />

              <TextInput
                id={"environment_form__name"}
                label={"Display Name"}
                onChange={(event: ChangeEvent<HTMLInputElement>) =>
                  onInputChange("display_name", event.target.value)
                }
              />

              <FileInput
                id={"environment_form__file"}
                label={"Upload Enviromnent file."}
                onChange={onFileChange}
              />

              {!isLoading ? (
                <Button label={"Submit"} type="submit" />
              ) : (
                <Spinner />
              )}
            </>
          )}
        </form>
      </div>
    </Modal>
  );
};
